import getUrl from './getUrl.js';

export default function singleOrder(idOrder) {
  return fetch(`${getUrl()}/v2/order/${idOrder}`, {
    method: 'GET',
    headers: {
      'Content-type':'application/json'
    },
    credentials: 'include',
  })
  .then((res) => res.json())
}